<template>
  <div
    class="order-type-choose-base"
    :class="{
      'order-type-choose-desktop': !isMobile(),
      'order-type-choose-mobile': isMobile(),
    }"
    style="padding: 0 1.25rem 0 0.25rem"
  >
    <div class="order-type-option" v-if="showDelivery">
      <div
        class="option-block cursorPointer  btn-lg"
        :class="{ shadow: isMobile() }"
        @click="chooseOrderType(0)"
        :style="getOptionStyles(0)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42.286"
          height="35.382"
          viewBox="0 0 42.286 35.382"
          class="order-type-icon order-type-delivery"
        >
          <defs>
            <svg:style type="text/css">
              {{deliveryIconStyles}}
            </svg:style>
          </defs>
          <g transform="translate(0 -0.001)">
            <path
              class="a"
              d="M2.866,60.163H15.511V48.32H0V63.83H2.866Z"
              transform="translate(0 -48.319)"
            />
            <path
              class="a"
              d="M78.238,228.557a2.445,2.445,0,1,0,0-4.89H65.173v4.889Z"
              transform="translate(-59.863 -209.38)"
            />
            <path
              class="a"
              d="M115.345,403.677a4.889,4.889,0,0,0,9.779,0Z"
              transform="translate(-105.946 -374.721)"
            />
            <path
              class="a"
              d="M101.444,152.925c.237,0,.471.012.7.034l-1.764-9.405h2.445v-2.444h-2.9l-.455-2.444H89.89v2.444h3.768l2.323,14.259H87.031l-1.422-3.209a4.858,4.858,0,0,1-2.621.765H71.171a8.5,8.5,0,0,0-.827,3.667v1.223H94.529a7.346,7.346,0,0,1,6.914-4.889Z"
              transform="translate(-64.613 -131.302)"
            />
            <circle
              class="a"
              cx="4.889"
              cy="4.889"
              r="4.889"
              transform="translate(31.388 34.19) rotate(-82.996)"
            />
          </g>
        </svg>
        <span>Delivery</span>
      </div>
    </div>
    <div class="order-type-option" v-if="showPickup">
      <div
        class="option-block cursorPointer  btn-lg"
        :class="{ shadow: isMobile() }"
        @click="chooseOrderType(2)"
        :style="getOptionStyles(2)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30.521"
          height="35.743"
          viewBox="0 0 30.521 35.743"
          class="order-type-icon order-type-pickup"
        >
          <defs>
            <svg:style type="text/css">
              {{pickupIconStyles}}
            </svg:style>
          </defs>
          <g transform="translate(-8.09 -4)">
            <path
              class="a"
              d="M36.754,39.644,38.611,18H8.09L9.947,39.644a.72.72,0,0,1-.032.262l-1.634,4.9h30.14l-1.639-4.9A.72.72,0,0,1,36.754,39.644ZM33.563,36.51a1.915,1.915,0,0,1-1.917,1.915H15.053a1.915,1.915,0,0,1-1.915-1.915V35.233a.638.638,0,0,1,.638-.638h.638V33.319a8.945,8.945,0,0,1,8.3-8.905V23.106H21.436a.638.638,0,0,1,0-1.277h3.829a.638.638,0,1,1,0,1.277H23.989v1.308a8.945,8.945,0,0,1,8.3,8.905V34.6h.638a.638.638,0,0,1,.638.638Z"
              transform="translate(0 -5.064)"
            />
            <path
              class="a"
              d="M35.319,37.659a7.659,7.659,0,1,0-15.319,0v1.277H35.319Z"
              transform="translate(-4.308 -9.405)"
            />
            <path
              class="a"
              d="M18.638,46H18v.638a.638.638,0,0,0,.638.638h16.6a.638.638,0,0,0,.638-.638V46Z"
              transform="translate(-3.585 -15.193)"
            />
            <path
              class="a"
              d="M19.553,7.829H33.6v3.829h2.553V7.829L33.6,4H19.553L17,7.829v3.829h2.553Z"
              transform="translate(-3.223)"
            />
          </g>
        </svg>
        <span>Pick up</span>
      </div>
    </div>
    <div class="order-type-option" v-if="showDinein">
      <div
        class="option-block cursorPointer  btn-lg"
        :class="{ shadow: isMobile() }"
        @click="chooseOrderType(1)"
        :style="getOptionStyles(1)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42.429"
          height="35.294"
          viewBox="0 0 42.429 35.294"
          class="order-type-icon order-type-dinein"
        >
          <defs>
            <svg:style type="text/css">
              {{dineinIconStyles}}
            </svg:style>
          </defs>
          <g transform="translate(-0.002 -43)">
            <path
              class="a"
              d="M65.2,47.759a8.952,8.952,0,0,0,1.2-3.388A1.242,1.242,0,0,0,65.168,43H52.243a1.243,1.243,0,0,0-1.233,1.394,9.07,9.07,0,0,0,1.259,3.38,7.225,7.225,0,0,0,2.888,2.66h7.189A7.074,7.074,0,0,0,65.2,47.76Z"
              transform="translate(-46.774 0)"
            />
            <path
              class="a"
              d="M289.2,47.759a8.951,8.951,0,0,0,1.2-3.388A1.242,1.242,0,0,0,289.168,43H276.243a1.242,1.242,0,0,0-1.233,1.394,9.069,9.069,0,0,0,1.258,3.38,7.226,7.226,0,0,0,2.888,2.66h7.189A7.073,7.073,0,0,0,289.2,47.76Z"
              transform="translate(-252.216 0)"
            />
            <path
              class="a"
              d="M138.279,292.28v11.944h-8.037a1.244,1.244,0,1,0,0,2.488H148.8a1.244,1.244,0,1,0,0-2.488h-8.037V292.28a3.461,3.461,0,0,0-2.488,0Z"
              transform="translate(-118.311 -228.419)"
            />
            <path
              class="a"
              d="M39.923,163.986a1.789,1.789,0,0,0-1.713-1.274h-34A1.789,1.789,0,0,0,2.5,163.986L.04,172.153a.9.9,0,0,0,.848,1.155.9.9,0,0,0,.219-.028c2.226-.559,2.7-2.338,5.73-2.338,3.594,0,3.594,2.505,7.189,2.505s3.594-2.505,7.189-2.505,3.594,2.505,7.189,2.505,3.594-2.505,7.189-2.505c3.029,0,3.5,1.779,5.73,2.338a.888.888,0,0,0,1.067-1.128Z"
              transform="translate(0 -109.794)"
            />
          </g>
        </svg>
        <span>Dine In</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
  CONSTANT_ORDER_TYPE_DINEIN,
} from "../../../constans/strings";

export default {
  name: "ChooseOrderType",
  props: {
    showDelivery: {
      type: Boolean,
      required: true,
    },
    showDinein: {
      type: Boolean,
      required: true,
    },
    showPickup: {
      type: Boolean,
      required: true,
    },
    chosenIndex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  created() {
    const hasOrderType = orderTypeHelper.getOrderType();
    const skipFirstStep = orderTypeHelper.getSkipFirstStep();

    if(hasOrderType && skipFirstStep) {
      switch (hasOrderType) {
        case CONSTANT_ORDER_TYPE_DELIVERY:
          this.chooseOrderType(0);
          break;
        case CONSTANT_ORDER_TYPE_PICKUP:
          this.chooseOrderType(2);
          break;
        case CONSTANT_ORDER_TYPE_DINEIN:
          this.chooseOrderType(1);
          break;
      }
    }
  },
  computed: {
    ...mapGetters([
      "desktopStyles",
      // "getMenuTypes",
    ]),
    iconActiveColor() {
      return this.desktopStyles.btn.color;
    },
    iconInactiveColor() {
      return this.desktopStyles.btn.background;
    },
    deliveryIconStyles() {
      const fillColor =
        this.chosenIndex === 0 || this.isMobile()
          ? this.iconActiveColor
          : this.iconInactiveColor;
      return ".order-type-delivery .a{fill:".concat(fillColor, ";}");
    },
    pickupIconStyles() {
      const fillColor =
        this.chosenIndex === 2 || this.isMobile()
          ? this.iconActiveColor
          : this.iconInactiveColor;
      return ".order-type-pickup .a{fill:".concat(fillColor, ";}");
    },
    dineinIconStyles() {
      const fillColor =
        this.chosenIndex === 1 || this.isMobile()
          ? this.iconActiveColor
          : this.iconInactiveColor;
      return ".order-type-dinein .a{fill:".concat(fillColor, ";}");
    },
  },
  methods: {
    getOptionStyles(index) {
      const styles = { ...this.desktopStyles.btn };
      styles["border-radius"] = "5px";
      if (index === this.chosenIndex || this.isMobile()) {
        return styles;
      } else {
        return {
          ...styles,
          background: "#EBEBEB",
          color: styles.background,
        };
      }
    },
    chooseOrderType(index) {
      this.$emit("order-type-changed", index);
    },
  },
};
</script>
